import type { ToolTipInfo } from "@incytestudios/ddv/types/common";

export function toolTipFilter(
  tti: ToolTipInfo,
  activeDataSets: boolean[]
): ToolTipInfo {
  return activeDataSets.reduce((acc, dataSet, i) => {
    if (dataSet && tti[i]) {
      acc[i] = tti[i];
    }
    return acc;
  }, {} as ToolTipInfo);
}
